import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row justify-content-center align-items-center" }
const _hoisted_3 = { class: "col-lg-6 col-md-12" }
const _hoisted_4 = { class: "movies-video-content" }
const _hoisted_5 = { class: "col-lg-6 col-md-12" }
const _hoisted_6 = { class: "movies-video-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_lightgallery = _resolveComponent("lightgallery")!

  return (_openBlock(), _createElementBlock("div", {
    class: "movies-video-area",
    style: _normalizeStyle({ backgroundImage: `url(${_ctx.backgroundImage})` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sub" }, "الأعلى تقييماً اليوم", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("h1", null, "سيرفر loay iptv فائق الثبات", -1)),
            _createElementVNode("p", null, [
              _cache[1] || (_cache[1] = _createTextVNode(" استمتع بأقوى تجربة مشاهدة بدون تقطيع. نوفر لك الوصول الفوري لأكثر من 10,000 قناة مباشرة بجودة 4K و FHD، بالإضافة إلى أضخم مكتبة أفلام ومسلسلات مترجمة ومحدثة يومياً تناسب كافة أجهزة العائلة. ", -1)),
              _createVNode(_component_RouterLink, { to: "/services-details" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("اقرأ المزيد", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[4] || (_cache[4] = _createStaticVNode("<ul class=\"btn-list\"><li><a href=\"https://wa.me/447429916178\" target=\"_blank\" class=\"btn\"><span class=\"border-style\">اشترك الآن</span></a></li><li><a href=\"https://wa.me/447429916178\" target=\"_blank\" class=\"btn\"><span class=\"border-style\">طلب تجربة مجانية</span></a></li></ul>", 1))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_lightgallery, {
              settings: { speed: 500, plugins: _ctx.plugins }
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createElementVNode("a", {
                  href: "https://youtu.be/e1GrRouA5D8?si=S8NlTgzeW0HQ6m30",
                  class: "video-btn"
                }, [
                  _createElementVNode("i", { class: "ri-play-fill" })
                ], -1)
              ]))]),
              _: 1
            }, 8, ["settings"])
          ])
        ])
      ])
    ])
  ], 4))
}